import set from 'lodash/set';

import { CONTRIBUTION_MODES } from '@lumapps/contents/constants';
import createSlice, { type PayloadAction } from '@lumapps/redux/createSlice';

export interface ContentEditorState {
    contributionMode: CONTRIBUTION_MODES;
}

export const initialContentEditorState: ContentEditorState = {
    contributionMode: CONTRIBUTION_MODES.WRITER,
};

export const { reducer: contentEditorReducer, actions: contentEditorActions } = createSlice({
    initialState: initialContentEditorState,
    domain: 'content-editor',
    reducers: {
        updateContributionMode: (state: ContentEditorState, action: PayloadAction<CONTRIBUTION_MODES>) => {
            set(state, 'contributionMode', action.payload);
        },
    },
});
